class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  static checkAndUpdateBodyScroll() {
    // Check if any header menu is open
    const allHeaderMenus = document.querySelectorAll('header-menu');
    const anyMenuOpen = Array.from(allHeaderMenus).some(menu => {
      const details = menu.querySelector('details');
      return details && details.hasAttribute('open');
    });

    if (anyMenuOpen) {
      // Store original overflow value if not already stored
      if (HeaderMenu.originalBodyOverflow === undefined) {
        HeaderMenu.originalBodyOverflow = document.body.style.overflow || '';
      }
      document.body.style.overflow = 'hidden';
    } else {
      // Restore body scrolling when all menus are closed
      if (HeaderMenu.originalBodyOverflow !== undefined) {
        document.body.style.overflow = HeaderMenu.originalBodyOverflow;
        HeaderMenu.originalBodyOverflow = undefined;
      }
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Prevent body scrolling when any menu is open
    HeaderMenu.checkAndUpdateBodyScroll();

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    super.close();
    // Check and update body scroll after closing
    HeaderMenu.checkAndUpdateBodyScroll();
  }
}

customElements.define('header-menu', HeaderMenu);
